import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { RetornoSelecao } from '../../../../shared/gridview/RetornoSelecao';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ServiceAppService } from './../../../../security/service-app.service';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { FiltroService } from './../../../../shared/filtro/filtro.service';
import { VorModel } from './../vor.model';
import { VorService } from './../vor.service';

@Component({
  selector: 'app-vor',
  templateUrl: './vor.component.html',
  styleUrls: ['./vor.component.css']
})
export class VorComponent extends ListaBase implements OnInit {
  //Columns
  subscription;
  columns: any[];
  observacaoParada: any;
  statusObservacaoParada: string = '';
  displayObservacao = false;
  linhaObservacaoSelecionada: any;
  _selectedColumns: any[];
  tipoDataOptions = [];
  loading = false;
  data: VorModel[] = [];
  filtros: any = {
    dealers: undefined,
    chassi: null,
    numero: null,
    motivo: null,
    modelo: null,
    andamento: null,
    dias: null,
    data_inicial: null,
    data_final: null,
    tipo_data: null
  };
  dealers = [];
  motivoParada: Array<{ descricao: string, id: string }> = [];
  andamentos: Array<{ descricao: string, id: string }> = [];
  selectedDealer: any;
  display: boolean = false;
  filterName: any[];
  displayEdit: boolean = false;
  id: any;
  vorData: any = {};
  idOs: any;
  idOrdemServico: any;
  isJLR: boolean = false;
  first: number = 0;

  dadosTranslate = {
    "Número da O.S.": "vorPCA.gridHeader.osNumber",
    "Dealer": "vorPCA.gridHeader.dealer",
    "Cliente": "vorPCA.gridHeader.cliente",
    "Modelo": "vorPCA.gridHeader.modelo",
    "Chassi": "vorPCA.gridHeader.chassi",
    "Tipo O.S.": "vorPCA.gridHeader.tipoOs",
    "Tipo O.S. Descrição": "vorPCA.gridHeader.tipoOsDescricao",
    "Data de Liberação": "vorPCA.gridHeader.liberacao",
    "Valor": "vorPCA.gridHeader.valor",
    "Abertura O.S.": "vorPCA.gridHeader.aberturaOs",
    "Motivo da Parada": "vorPCA.gridHeader.motivoParada",
    "Andamento": "vorPCA.gridHeader.andamento",
    "Ações": "vorPCA.gridHeader.acoes",
  }
  isFabrica: any;

  constructor(
    service: VorService,
    toastr: ToastrService,
    router: Router,
    private filter: FiltroService,
    private currency: CurrencyPipe,
    private exportExcelService: ExportExcelService,
    private appService: ServiceAppService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private servico: VorService) {
    super(service, toastr, router);
    this.nomeModulo = 'pca-vor';
  }

  ngOnInit() {
    this.verificarMarcaJLR();
    this.getAll();
    this.changeLanguageValue();
    this.preencherTipoData();

    this.columns = [
      { field: 'detalhe', header: '', width: '40px' },
      { field: 'numeroOs', header: 'vorPCA.gridHeader.osNumber', width: '125px' },
      { field: 'idNumeroOs', header: 'vorPCA.gridHeader.idNumeroOS', width: '125px' },
      { field: 'nome', header: 'vorPCA.gridHeader.dealer', width: '300px' },
      { field: 'cliente', header: 'vorPCA.gridHeader.cliente', width: '300px' },
      { field: 'modelo', header: 'vorPCA.gridHeader.modelo', width: '300px' },
      { field: 'anoModelo', header: 'vorPCA.gridHeader.anoModelo', width: '110px' },
      { field: 'chassi', header: 'vorPCA.gridHeader.chassi', width: '170px' },
      { field: 'dataHandover', header: 'vorPCA.gridHeader.dataHandover', width: '175px' },
      { field: 'imobilizado', header: 'vorPCA.gridHeader.imobilizado', width: '130px' },
      { field: 'tipoOs', header: 'vorPCA.gridHeader.tipoOs', tooltipPosition: 'top', width: '120px' },
      { field: 'tipoOsDescricao', header: 'vorPCA.gridHeader.tipoOsDescricao', tooltipPosition: 'top', width: '120px' },
      { field: 'valor', header: 'vorPCA.gridHeader.valor', type: this.currency, arg1: ' ', width: '120px' },
      { field: 'aberturaOs', header: 'vorPCA.gridHeader.aberturaOs', width: '150px' },
      { field: 'tempoParado', header: 'vorPCA.gridHeader.diasAbertos', width: '175px' },
      { field: 'quantidadeOsAberta', header: 'vorPCA.gridHeader.quantidadeOsAberta', width: '175px' },
      { field: 'dtFimServico', header: 'vorPCA.gridHeader.dtFimServico', width: '175px' },
      { field: 'liberacao', header: 'vorPCA.gridHeader.liberacao', width: '175px' },
      { field: 'motivoParada', header: 'vorPCA.gridHeader.motivoParada', tooltipPosition: 'top', width: '200px' },
      { field: 'andamento', header: 'vorPCA.gridHeader.andamento', tooltipPosition: 'top', width: '200px' },
      { field: 'observacao', header: 'vorPCA.gridHeader.observacaoParada', tooltipPosition: 'top', width: '200px' },

    ];

    this._selectedColumns = this.columns;
    this.verificarUsuario();
    this.carregarAndamento();

  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  getAll() {
    this.first = 0;

    if (this.filtros.dias !== null && this.filtros.dias !== undefined && this.filtros.dias !== '') {
    const d = Number(this.filtros.dias);
    this.filtros.dias = (!isNaN(d) && d >= 0) ? String(d) : null;   // <-- String(d)
} else {
    this.filtros.dias = null;
}

    this.preencherDealers();

    let objFiltro: Filtros = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {

        if (chave === 'andamento' && Array.isArray(this.filtros[chave])) {
          if (this.filtros[chave].length > 0) {
            const andamentoOriginal = this.filtros[chave];

            this.filtros[chave] = andamentoOriginal.join(',');

            super.incluirItemFiltro(chave, objFiltro);

            this.filtros[chave] = andamentoOriginal;
          }
        } else {
          super.incluirItemFiltro(chave, objFiltro);
        }
      }
    }

    this.loading = true;
    this.service.buscar(objFiltro).then(res => {
      this.data = res.dados;

      let temIdNumeroOsDiferente = false;

      this.data.forEach(dados => {
        dados.aberturaOs = dados.aberturaOs.substring(0, 10);
        dados.aberturaOs = moment(dados.aberturaOs).format('DD/MM/YYYY');

        if (dados.liberacao && moment(dados.liberacao).isValid()) {
          dados.liberacao = dados.liberacao.substring(0, 10);
          dados.liberacao = moment(dados.liberacao).format('DD/MM/YYYY');
        } else {
          dados.liberacao = '-';
        }

        if (!dados.idNumeroOs) {
          dados.idNumeroOs = '-';
        }

        if (dados.idNumeroOs && String(dados.idNumeroOs) !== String(dados.numeroOs) && dados.idNumeroOs !== '-') {
          temIdNumeroOsDiferente = true;
        }
      });

      if (!temIdNumeroOsDiferente) {
        this._selectedColumns = this.columns.filter(col => col.field !== 'idNumeroOs');
      } else {
        if (!this._selectedColumns.find(col => col.field === 'idNumeroOs')) {
          const idNumeroOsCol = this.columns.find(col => col.field === 'idNumeroOs');
          if (idNumeroOsCol) {
            const index = this._selectedColumns.findIndex(col => col.field === 'numeroOs');
            if (index !== -1) {
              this._selectedColumns.splice(index + 1, 0, idNumeroOsCol);
            }
          }
        }
      }

      for (const dados of res?.dados) {
        dados.valor = this.conversaoLibraConverte.conversaoLibra(dados.valor, null, null)
      }

      this.loading = false
    });
    this.carregarAndamento();
    this.display = false
  }

  private verificarMarcaJLR() {
    this.appService.getDados(`/admin/capturarMarca`).subscribe(res => {
      const marca = res.nome;
      this.isJLR = marca.includes("JLR");
      if (this.isJLR) {
        this.columns = [...this.columns];
      } else {
        this.columns = this.columns.filter(col => col.field !== 'dataHandover');
      }
    });
  }

  private verificarUsuario() {
    this.appService.getDados(`/analise_garantia/usuario_fabrica`).subscribe(res => {
      const usuario = res;
      this.isFabrica = usuario;

      if (!this.isFabrica) {
        this.columns = this.columns.filter(col => col.field !== 'quantidadeOsAberta');
      }
    });
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 == null && value2 == null) {
        result = 0;
      } else if (typeof value1 === 'string' && typeof value2 === 'string') {
        if ((event.field === 'aberturaOs')) {
          const x = value1.split('/');
          const y = value2.split('/');
          value1 = x[2] + x[1] + x[0];
          value2 = y[2] + y[1] + y[0];
        }

        result = value1.localeCompare(value2);
      } else {
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
      }

      return (event.order * result);
    });
  }

  exportExcel() {
    this.exportExcelService.nomeModulo = this.nomeModulo;
    const camposData = ['aberturaOs', 'liberacao', 'dtFimServico', 'dataHandover'];

    this.exportExcelService.ExportTOExcelJSON(
      this.data.map(r => {
        let linha = {};

        this._selectedColumns.forEach(c => {
          if (c.field === 'edit' || c.field === 'observacao') {
            return;
          }

          if (c.field === 'dataHandover') {
            if (this.isJLR) {
              const val = r[c.field];

              if (val && val !== '-') {
                if (typeof val === 'string' && val.includes('/')) {
                  const partes = val.split('/');

                  linha[this.translateHeader(c.header)] = new Date(
                    Number(partes[2]),
                    Number(partes[1]) - 1,
                    Number(partes[0])
                  );
                } else {
                  linha[this.translateHeader(c.header)] = new Date(val);
                }
              } else {
                linha[this.translateHeader(c.header)] = '';
              }
            } else {
              linha[this.translateHeader(c.header)] = '';
            }

            return;
          }

          if (c.field === 'quantidadeOsAberta') {
            if (this.isFabrica) {
              linha[this.translateHeader(c.header)] = r[c.field];
            } else {
              linha[this.translateHeader(c.header)] = '';
            }

            return;
          }

          if (camposData.includes(c.field)) {
            const valorData = r[c.field];

            if (valorData && valorData !== '-') {
              if (typeof valorData === 'string' && valorData.includes('/')) {
                const partes = valorData.split('/');

                linha[this.translateHeader(c.header)] = new Date(
                  Number(partes[2]),
                  Number(partes[1]) - 1,
                  Number(partes[0])
                );
              } else {
                linha[this.translateHeader(c.header)] = new Date(valorData);
              }
            } else {
              linha[this.translateHeader(c.header)] = '';
            }

            return;
          }

          linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
        });

        linha['Observação'] = this.getTextoObservacaoExcel(r);
        linha['Status Observação'] = this.getStatusObservacaoExcel(r);

        return linha;
      })
    );
  }

  translateHeader(item) {
    if (item == "vorPCA.gridHeader.osNumber") {
      return this.translate.currentLang == "br" ? "Número O.S." : "S.O. Number";
    }
    if (item == "vorPCA.gridHeader.idNumeroOS") {
      return this.translate.currentLang == "br" ? "ID Número O.S." : "ID S.O. Number";
    }
    if (item == "vorPCA.gridHeader.dealer") {
      return "Dealer";
    }
    if (item == "vorPCA.gridHeader.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "vorPCA.gridHeader.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "vorPCA.gridHeader.anoModelo") {
      return this.translate.currentLang == "br" ? "Ano/Modelo" : "Year/Model";
    }
    if (item == "vorPCA.gridHeader.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "vorPCA.gridHeader.imobilizado") {
      return this.translate.currentLang == "br" ? "Imobilizado" : "Imobilized";
    }
    if (item == "vorPCA.gridHeader.tipoOs") {
      return this.translate.currentLang == "br" ? "Tipo O.S." : "S.O. Types";
    }
    if (item == "vorPCA.gridHeader.tipoOsDescricao") {
      return this.translate.currentLang == "br" ? "Tipo O.S. Descrição" : "S.O. Types Description";
    }
    if (item == 'vorPCA.gridHeader.liberacao') {
      return this.translate.currentLang == "br" ? "Data de Liberação" : "Release Date";
    }
    if (item == "vorPCA.gridHeader.valor") {
      return this.translate.currentLang == "br" ? "Valor" : "Value";
    }
    if (item == "vorPCA.gridHeader.aberturaOs") {
      return this.translate.currentLang == "br" ? "Abertura O.S." : "S.O. Opening";
    }
    if (item == "vorPCA.gridHeader.dataHandover") {
      return this.translate.currentLang == "br" ? "Data Handover" : "Handover Date";
    }
    if (item == "vorPCA.gridHeader.diasAbertos") {
      return this.translate.currentLang == "br" ? "Dias Abertos" : "Open Days";
    }
    if (item == "vorPCA.gridHeader.quantidadeOsAberta") {
      return this.translate.currentLang == "br" ? "Quantidade O.S. Aberta" : "Open S.O. Quantity";
    }
    if (item == "vorPCA.gridHeader.dtFimServico") {
      return this.translate.currentLang == "br" ? "Último Apontamento" : "Last Apointment";
    }
    if (item == "vorPCA.gridHeader.motivoParada") {
      return this.translate.currentLang == "br" ? "Motivo da Parada" : "Reason for Stoping";
    }
    if (item == "vorPCA.gridHeader.andamento") {
      return this.translate.currentLang == "br" ? "Andamento" : "Progress";
    }
    if (item == "vorPCA.gridHeader.observacaoParada") {
      return this.translate.currentLang == "br" ? "Observação" : "Observation";
    }
  }

  translateField(item) {
    if (item == "vorPCA.motivoParadaValores.aguardandoPecas" || item == "Aguardando Peça") {
      return this.translate.currentLang == "br" ? "Aguardando Peça" : "Awaiting Part";
    }
    if (item == "vorPCA.motivoParadaValores.osAbertaMaisDezDias" || item == "O.S. Aberta a mais de 10 dias") {
      return this.translate.currentLang == "br" ? "O.S. Aberta a mais de 10 dias" : "S.O. Open for more than 10 days";
    }

    return item;
  }

  getTranslate(value) {
    if (value == "vorPCA.motivoParadaValores.aguardandoPecas" || value == "Aguardando Peça") {
      return this.translate.currentLang == "br" ? "Aguardando Peça" : "Awaiting Part";
    }
    if (value == "vorPCA.motivoParadaValores.osAbertaMaisDezDias" || value == "O.S. Aberta a mais de 10 dias") {
      return this.translate.currentLang == "br" ? "O.S. Aberta a mais de 10 dias" : "S.O. Open for more than 10 days";
    }

    return this.dadosTranslate[value];
  }

  //Dialogs
  showDialog() {
    this.display = true;
  }

  getId(index: number) {
    this.displayEdit = true
    this.id = this.data[index].id
  }

  //Filters
  cleanFilter() {
    this.filtros.dealers = undefined
    this.filtros.chassi = null
    this.filtros.numero = null
    this.filtros.motivo = null
    this.filtros.modelo = null
    this.filtros.andamento = null
    this.filtros.dias = null
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  edit() {
    this.appService.putDados('/vor/' + this.id, this.vorData).subscribe(res => {
      this.getAll();
    });
    this.displayEdit = false
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.dealers
      || this.filtros.chassi
      || this.filtros.numero
      || this.filtros.motivo
      || this.filtros.modelo
      || this.filtros.andamento
  }

  private preencherDealers() {
    this.filter.buscar('dealer').then(res => { this.dealers = res.filtros; });
  }
  public getStatusObservacaoExcel(data: any): string {
    const status = this.normalizarStatusObservacao(data?.statusObservacaoParada);

    if (status === 'concluido') {
      return 'OK';
    }

    if (status === 'em analise') {
      return 'N/A';
    }

    return '';
  }

  public getTextoObservacaoExcel(data: any): string {
    if (!data || data.observacaoParada == null) {
      return '';
    }

    const texto = data.observacaoParada.toString().trim();

    if (!texto || texto.toLowerCase() === 'null') {
      return '';
    }

    return texto;
  }


  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getAll();
    });
  }


  private carregarMotivoParada(filtros?: Filtros) {
    this.servico.carregarMotivosDropdown(filtros).then(res => {
      this.motivoParada = (res || []).map(item => ({
        descricao: item.descricao,
        id: item.id != null ? String(item.id) : ''
      }));
    }).catch(() => {
      this.motivoParada = [];
    });
  }

  private carregarAndamento() {
    this.servico.carregarAndamentosDropdown().then(res => {
      this.andamentos = (res || []).map(item => ({
        descricao: item.descricao,
        id: item.id != null ? String(item.id) : ''
      }));
    }).catch(() => {
      this.andamentos = [];
    });
  }

  public getLegendaObservacao(valor: any): string {
    const status = (valor || '').toLowerCase();

    if (status === 'concluido') {
      return 'Concluído';
    }

    if (status === 'em analise') {
      return 'Em análise';
    }

    return valor || '';
  }


  public visualizar(registros) {
    const retorno: RetornoSelecao = new RetornoSelecao();
    retorno.novoCadastro = false;
    retorno.registro = registros.idOrdemServico;
    this.idOs = retorno.registro;
    this.servico.ver(retorno);
  }

  public voltar() {
    this.idOs = null;
  }
  public salvar() {
    const statusNormalizado = this.normalizarStatusObservacao(this.statusObservacaoParada);

    const dto = {
      id: this.idOrdemServico,
      descricao: this.observacaoParada,
      status: statusNormalizado
    };

    this.servico.atualizarObservacao(dto).then(() => {
      this.data
        .filter((item: any) => String(item.idOrdemServico) === String(this.idOrdemServico))
        .forEach((linha: any) => {
          linha.observacaoParada = this.observacaoParada;
          linha.statusObservacaoParada = statusNormalizado;
        });

      this.statusObservacaoParada = statusNormalizado;
      this.displayObservacao = false;
    });
  }
  public abrirObservacao(dado: any) {
    this.displayObservacao = true;
    this.observacaoParada = dado.observacaoParada || '';
    this.statusObservacaoParada = dado.statusObservacaoParada || '';
    this.idOrdemServico = dado.idOrdemServico;
  }

  public selecionarStatusObservacao(status: string): void {
    this.statusObservacaoParada = this.normalizarStatusObservacao(status);
  }

  public getClasseObservacao(data: any): string {
    const status = this.normalizarStatusObservacao(data?.statusObservacaoParada);

    if (status === 'concluido') {
      return 'p-button-success';
    }

    if (status === 'em analise') {
      return 'p-button-warning';
    }

    return 'p-button-info';
  }
  private normalizarStatusObservacao(valor: any): string {
    return (valor || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  private preencherTipoData() {
    this.filtros.tipo_data = "1";
    this.appService.getDados(`/admin/capturarMarca`).subscribe((res) => {
      const marca = res.nome;

      if (marca == 'JLR') {
        this.tipoDataOptions = [
          { name: 'Data de emissão/Abertura OS', value: "1" },
          { name: 'Data de Handover', value: "2" },
          { name: 'Data de Liberação', value: "3" },
          { name: 'Último Apontamento', value: "4" }
        ];
      } else {
        this.tipoDataOptions = [
          { name: 'Data de emissão/Abertura OS', value: "1" },
          { name: 'Data de Liberação', value: "3" },
          { name: 'Último Apontamento', value: "4" }
        ];
      }
    });
  }

  public onSelectDataInicial(event: Date) {
    this.filtros.data_inicial = event;
  }

  public onSelectDataFinal(event: Date) {
    this.filtros.data_final = event;
  }

  public capturarValor(valor: any) {
    this.filtros.tipo_data = valor;
  }
  public bloquearNegativo(event: KeyboardEvent): void {
  if (event.key === '-' || event.key === 'e' || event.key === '+') {
    event.preventDefault();
  }
}
}